import React, {useState} from 'react';
import SaveDashboardMetaPopup from './SaveDashboardMetaPopup';

function SavingDashboardMetaWrapper({
  id,
  dashboard,
  disabled=false,
  onSaveCallback,
  children,
}) {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const dataToBeSaved = {
    name: dashboard.name,
    isSaved: true,
    isPublic: dashboard.isPublic,
  }

  return (
    <>
      <div onClick={() => {setIsPopupOpen(true)}}>
        {children}
      </div>

      <SaveDashboardMetaPopup
        id={id}
        dashboard={dashboard}
        isPopupOpen={disabled ? false : isPopupOpen}
        closePopup={() => setIsPopupOpen(false)}
        dataToBeSaved={dataToBeSaved}
        onSaveCallback={onSaveCallback}
      />
    </>
  );
}

export default SavingDashboardMetaWrapper;